import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from "@angular/platform-browser";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { slice } from 'lodash-es';
import { DementiaSeries } from '../../models/dementia-series/dementia-series.model';
import { DementiaSeriesService } from '../../services/dementia-series.service';
import { ToastsService } from '../../services/toasts.service';
import { Base } from '../base/base';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';
import { ErrorHandler } from '@angular/core';

@Component({
  selector: 'safetydirector-dementia-series',
  templateUrl: './dementia-series.component.html',
  styleUrls: ['./dementia-series.component.css']
})
export class DementiaSeriesComponent extends Base implements OnInit, OnChanges, OnDestroy {
  private BusyA;
  private BusyB;
  public dementiaOverview: DementiaSeries;
  public dementiaSeries: DementiaSeries[];
  public selectedSeries: DementiaSeries;
  public selectedSeriesUrl: SafeResourceUrl;

  public industry: string = '';

  public pageName = "Dementia Care Series";

  constructor(
    private dementiaSeriesService: DementiaSeriesService,
    private sanitized: DomSanitizer,
    private toastsService: ToastsService,
    private modalService: NgbModal,
    private titleService: Title,
    private eventTrackingService: EventTrackingService,
    private errorHandler: ErrorHandler) {
    super();    
  }

  ngOnInit(): void {    
    this._getDementiaSeries();
    this.titleService.setTitle(this.basePageTitle + this.pageName);
  }

  private _getDementiaSeries() {
    const testError = new Error(`This is a test exception for the Dementia Series component.`);
    this.errorHandler.handleError(testError);
    
    this.industry = this.getIndustry();

    this.BusyA = this
      .dementiaSeriesService
      .getDementiaSeries()
      .subscribe((result: DementiaSeries[]) => {
        this.dementiaOverview = _.slice(result, 0, 1)[0];  // Get Position Zero for the Overview
        this.dementiaSeries = _.slice(result, 1, result.length); // Skip the first one as its the Overview
      });
  }

  public downloadFile(fileName, fileIcon) {


      // track download file event
      this.eventTrackingService.trackEvent('TrackEvent', {
        'Event' : EventName.dementiaSeriesDownloadFile
        ,'FileName': fileName
      });
    
    // Replace the file icon with a spinner, save the original icon to replace when download is complete
    let originalFileIconSrc = fileIcon.src;
    fileIcon.src = "../../assets/images/spinner.gif"

    this.BusyB = this
      .dementiaSeriesService
      .downloadFile(fileName)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        // Put back the original icon
        fileIcon.src = originalFileIconSrc;
        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });  
  }

  openModal(targetModal, series) {   
    const modalRef = this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
    this.selectedSeries = series;
    this.selectedSeriesUrl = this.sanitized.bypassSecurityTrustResourceUrl(series.url);

    // track openModal event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.dementiaSeriesOpenModal
      , 'DementiaSeries': this.selectedSeries.title
    });
  }

  ngOnChanges(): void {

  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }
    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }
  }
}
